import React from "react";
import "./Pages.css";
import chat from "../../assets/chat.png";

const Anzeige = () => {
  return (
    <div className="anzeige">
      <img width={300} src={chat} alt="Anzeige" />
      <p>
        Sehr geehrte Patienten
        <pre />

        <span style={{ color: "red" }}>
          am <strong>Freitag, den 14.08.2026</strong> wird{" "}
          <strong>keine reguläre Sprechstunde</strong> stattfinden.
          <pre />

          Die Praxis bleibt für Verordnungen und Terminvergabe von{" "}
          <strong>08:00 Uhr bis 11:00 Uhr</strong> für Sie offen.
          <pre />

          Bei <strong>dringenden Beschwerden</strong> wenden Sie sich an das{" "}
          <strong>nächstgelegene Krankenhaus</strong> oder{" "}
          <strong>telefonisch unter 116 117</strong> an den{" "}
          <strong>ärztlichen Bereitschaftsdienst.</strong>
          <pre />

          Im <strong>akuten Notfall</strong> rufen Sie den Rettungsdienst unter{" "}
          <strong>112</strong>.
          <pre />

          Ab <strong>Montag, den 17.08.2026</strong> findet wieder die{" "}
          <strong>reguläre Sprechstunde</strong> statt.
        </span>

        <pre />
        <pre />

        Wir sind eine Facharztpraxis, da kann es schon durchaus zu etwas längeren
        Wartezeiten kommen. Dafür bitte wir um Verständnis.
        <pre />
        <pre />

        Die Untersuchung bei Neupatienten ist immer etwas aufwändiger. Bitte planen
        Sie genügend Zeit ein.
        <pre />
        <pre />

        Wir haben mehrere Untersuchungs-/Behandlungsräume, deswegen kann es
        auch durchaus sein, dass ein Patient, der nach Ihnen kam, vor Ihnen aufgerufen
        wird.
        <pre />
        <pre />

        Viele Patienten kommen z.B. nur zur Blutabnahme, Katheterwechsel usw. und
        müssen an diesem Tag nicht zum Arzt.
        <pre />

        Das sind Untersuchungen, die von den Fachangestellten durchgeführt
        werden.
        <pre />
        <pre />

        An manchen Tagen haben wir auch Notfälle. Dies sind Patienten mit z.B.
        Koliken und unter Schmerzen können diese Patienten nicht warten und
        brauchen zeitnah eine Versorgung.
        <pre />
        <pre />

        Wir bitten um Ihr Verständnis
        <pre />

        Ihr URO-Praxisteam
        <pre />
        <pre />
      </p>
    </div>
  );
};

export default Anzeige;